export default __webpack_public_path__ + "static/media/BannerCO2Long.258f90e3.png";